import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class UnauthorizedInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: HttpRequest<any>,
    next: HttpHandler,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.handleUnauthorizedError(request, error),
        ),
      );
  }

  private handleUnauthorizedError(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: HttpRequest<any>,
    error: HttpErrorResponse,
  ) {
    const ignore401 = request.params.has('ignore401');

    if (error.status === 401 && !ignore401) {
      const loginUrl = `${window.location.origin}/login`;
      this.authService.logout({returnTo: loginUrl});
    }

    return throwError(error);
  }
}
